// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--24WuS","top-content":"_61cc05a7c9--top-content--2IJu3","trend":"_61cc05a7c9--trend--2xfuZ","description":"_61cc05a7c9--description--3OXZo"};